import type { IconSvgObject } from './types';

const AddFemaleIcon: IconSvgObject = [
  ["path", { d: "M13.5 21H2L2.05324 19.0125C2.0772 18.1177 2.6927 17.3479 3.5602 17.1276L7.99986 16V13.845C6.71508 13.6822 5.53024 13.397 4.49986 13.0161C4.99986 12.0322 5.49986 10.5563 5.49986 7.11264C5.49986 1.20919 10.9999 1.20912 12.4999 3.17672C15.4999 2.68499 15.4999 5.14483 15.4999 8.09655C15.4999 10.4579 16.1665 12.3602 16.4999 13.0161C15.4695 13.397 14.2846 13.6822 12.9999 13.845V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 22L18.5 15M15 18.5H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AddFemaleIcon;
